export enum CheckDataStatus {
  Initial = 'Initial',
  ValidateError = 'ValidateError',
  TechError = 'TechError',
  Success = 'Success',
}
